// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { paginatedAuditEventsResponseSchema } from '@/audit/api/types';
import queryString from 'query-string';

export interface FullAuditFilter {
  pageSize: number;
  pageNumber?: number;
  startDate?: string;
  endDate?: string;
  referenceRelations?: string[];
  sourceTypes?: string[];
  actorIds?: string[];
}

/**
 * Request a list of all audit events across the organization from the remote API.
 * This includes events from all objects (assets, items, projects, etc).
 */
export async function getFullAuditEvents(filter: FullAuditFilter) {
  const url = '/meta/full-audit';
  const response = await api.get(url, {
    paramsSerializer: (parameters) => queryString.stringify(parameters),
    params: {
      limit: filter.pageSize,
      page: filter.pageNumber,
      startDate: filter.startDate,
      endDate: filter.endDate,
      referenceRelation: filter.referenceRelations,
      sourceType: filter.sourceTypes,
      actorId: filter.actorIds,
    },
  });

  return parseResponse(paginatedAuditEventsResponseSchema, response.data, {
    schemaName: 'FullAuditEvents',
    endpoint: url,
  });
}
